import * as React from 'react';
import {useEffect, useState, useCallback, SetStateAction} from 'react';

import { GoogleMap, useLoadScript } from '@react-google-maps/api';
import {getGoogleMapsApiKey} from "../../utils/geolocationUtils";
import Marker from "./Marker";

const Map = (props) => {
    const { center, markers, initialZoom, mapTypeId } = props;
    const [map, setMap] = useState(null);
    const [indexMarker, setIndexMarker] = useState(0);
    const [markerItems, setMarkerItems] = useState([]);

    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey: getGoogleMapsApiKey(),
    });

    const onLoad = React.useCallback(function callback(map) {
        setMap(map)
    }, [])

    useEffect(() => {
        if (!map) return;
        setMarkerItems(markers);
    }, [markers, map]);

    const onUnmount = useCallback((map) => {
        setMap(null);
    }, []);

    const onSelectMarker = (marker, index) => {
        var latLng = new window.google.maps.LatLng(marker.lat, marker.lng);
        if (!!map) map.panTo(latLng);
        setIndexMarker(index);
        if (!!props.onSelectMarker) props.onSelectMarker(marker);
    };

    const buildMarkers = useCallback(() =>
        markerItems.map((m) => (
            <Marker
                key={`marker-` + m.id}
                marker={m}
                isSelected={indexMarker === String(m.id)}
                onClick={() => onSelectMarker(m, String(m.id))}
                onCloseClick={() => {
                    setIndexMarker(null);
                }}
            />
        )),
    );

    return !isLoaded || !!loadError ? (
        <></>
    ) : (
        <GoogleMap
            mapContainerStyle={{ height: '100%', width: '100%' }}
            center={center}
            zoom={ initialZoom }
            onLoad={onLoad}
            onUnmount={onUnmount}
            options={{
                disableDefaultUI: true,
                zoomControl: true,
                mapTypeId
            }}
        >
            { buildMarkers() }
        </GoogleMap>
    );
};

export default Map;
